<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span class="font-sz24">登录日志</span>
      <div class="head-text">
        <el-input
          placeholder="用户姓名"
          class="search-input"
          v-model="name"
        ></el-input>
        <el-date-picker
          class="width300-marr20"
          value-format="yyyy/MM/dd"
          v-model="timeArr"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changetime"
        >
        </el-date-picker>
        <el-input
          placeholder="ip地址"
          class="search-input"
          v-model="ip"
        ></el-input>
        <el-button @click="GetLoginRecordList" class="mar-r20" type="primary"
          >查询</el-button
        >
        <el-button @click="DelLoginRecord" class="mar-r20" type="danger"
          >删除记录</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      @selection-change="handleSelectionChange"
      v-loading="loading"
      :data="list"
      class="width100"
      max
      height="72vh"
    >
      <el-table-column
        align="center"
        type="selection"
        width="55"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="user04"
        label="用户姓名"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="user02"
        label="账户"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="lgrc03"
        label="登录终端型号"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="lgrc04"
        label="操作系统"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="lgrc05"
        label="IP"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="lgrc06"
        label="操作信息"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="lgrc07"
        label="登录时间"
      ></el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
import { GetLoginRecordList, DelLoginRecord } from "@/setAxios";
export default {
  data() {
    return {
      timeArr: [],
      name: "",
      time: "",
      ip: "",
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      list: null,
      multipleSelection: []
    };
  },
  created() {
    this.GetLoginRecordList();
  },
  methods: {
    async DelLoginRecord() {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let lgrcidArr = [];
        this.multipleSelection.forEach(ele => {
          lgrcidArr.push(ele.lgrc01);
        });
        let lgrcid = lgrcidArr.join(",");
        let params = {
          lgrcid
        };
        DelLoginRecord(params).then(res => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.GetLoginRecordList();
          }
        });
      });
    },
    changetime(val) {
      if (val) {
        this.time = this.timeArr.join("-");
      } else {
        this.time = "";
      }
    },
    async GetLoginRecordList() {
      let params = {
        name: this.name,
        time: this.time,
        ip: this.ip,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      let res = await GetLoginRecordList({ params });
      this.list = res.Data.list;
      this.total = res.Data.total;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetLoginRecordList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetLoginRecordList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 80px;
  margin-top: 10px;
}
.changUpload {
  height: 50vh;
  text-align: center;
  .ZIP {
    width: 35%;
    height: 75%;
    margin-left: 10%;
    float: left;
    border: 2px solid #eee;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    p {
      font-size: 14px;
      margin-top: 30px;
      height: 50px;
    }
    img {
      width: 100px;
      margin-top: 50px;
    }
  }
  .ZIP:hover {
    background: #eee;
    border-color: skyblue;
  }
  .REVIT:hover {
    background: #eee;
    border-color: skyblue;
  }
  .REVIT {
    width: 35%;
    height: 75%;
    float: left;
    margin-left: 5%;
    border: 2px solid #eee;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    p {
      font-size: 14px;
      margin-top: 30px;
      height: 50px;
    }
    img {
      width: 100px;
      margin-top: 50px;
    }
  }
}
// 新增
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.search-input {
  width: 200px;
  margin-right: 20px;
}
.width300-marr20 {
  width: 300px;
  margin-right: 20px;
}
.mar-r20 {
  margin-right: 20px;
}
.width100 {
  width: 100%;
}
</style>
